import { render, staticRenderFns } from "./PointWriteLink.vue?vue&type=template&id=45c0ccaa&scoped=true&"
import script from "./PointWriteLink.vue?vue&type=script&lang=js&"
export * from "./PointWriteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0ccaa",
  null
  
)

export default component.exports